import { render, staticRenderFns } from "./Create-Pratica.vue?vue&type=template&id=0e36cbea&scoped=true&"
import script from "./Create-Pratica.vue?vue&type=script&lang=js&"
export * from "./Create-Pratica.vue?vue&type=script&lang=js&"
import style0 from "./Create-Pratica.vue?vue&type=style&index=0&id=0e36cbea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e36cbea",
  null
  
)

export default component.exports